import { render, staticRenderFns } from "./WellbeingCourse.vue?vue&type=template&id=5267275b"
import script from "./WellbeingCourse.vue?vue&type=script&lang=js"
export * from "./WellbeingCourse.vue?vue&type=script&lang=js"
import style0 from "./WellbeingCourse.vue?vue&type=style&index=0&id=5267275b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports